import React from "react";
import Drawer from "../Components/Drawer";
import PeopleForm from "./PeopleForm";

/**
 * People directory edit flow: generic Drawer + People-specific content.
 */
export default function PeopleProfileEditDrawer({
  open,
  person,
  formOptions = { departments: [], roles: [] },
  canEditEmploymentFields = false,
  onClose,
  onSaved,
}) {
  if (!person) {
    return null;
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      ariaLabelledBy="people-edit-drawer-title"
      backdropLabel="Close edit panel"
    >
      <PeopleForm
        key={String(person.id)}
        person={person}
        formOptions={formOptions}
        canEditEmploymentFields={canEditEmploymentFields}
        onClose={onClose}
        onSaved={onSaved}
      />
    </Drawer>
  );
}
